import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Mitarbeiter as MitarbeiterType } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';

export function Mitarbeiter({
  mitarbeiter,
  lehrjahr,
  beruf,
}: {
  mitarbeiter: MitarbeiterType;
  lehrjahr: string;
  beruf: Beruf;
}) {
  const initials =
    mitarbeiter.vorname[0].toUpperCase() +
    mitarbeiter.nachname[0].toUpperCase();

  return (
    <div className="sticky left-0 z-10 flex gap-2 border-r border-solid border-neutrals-200 p-1 bg-white">
      <Avatar>
        <AvatarImage
          alt={mitarbeiter.vorname + ' ' + mitarbeiter.nachname}
          src={mitarbeiter.imgUrl}
        />
        <AvatarFallback>{initials}</AvatarFallback>
      </Avatar>
      <div className="hidden md:flex md:flex-col min-w-0">
        <div className="text-sm text-neutrals-900 truncate">
          {mitarbeiter.vorname + ' ' + mitarbeiter.nachname}
        </div>
        <div className="text-xs text-neutrals-700">
          {lehrjahr + '⋅' + beruf.abkuerzung}
        </div>
      </div>
    </div>
  );
}
